<script setup lang="ts">
import type { ParsedImage } from "~/composables/useArticles";

withDefaults(
  defineProps<{
    image: ParsedImage;
    combo?: string;
  }>(),
  {
    combo: "dark-green",
  },
);
</script>

<template>
  <figure
    v-if="image.src"
    class="relative my-4 sm:mb-16 sm:mt-8"
  >
    <img
      v-if="image.src"
      :src="image.src"
      :alt="image.alt"
    />
    <figcaption
      v-if="image.caption"
      :class="combo"
      class="-translate-y-3 bg-(--background,var(--event-background)) p-6 text-base text-(--foreground) sm:absolute sm:-bottom-8 sm:-left-16 sm:max-w-[46%] sm:translate-y-0"
      v-text="image.caption"
    />
  </figure>
</template>
